var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-banner',{staticClass:"app-fullpage"},[[_vm._v(" "+_vm._s(_vm.alertText)+" "),_c('c-btn',{attrs:{"x-small":"","to":_vm.link}},[_vm._v(_vm._s(_vm.$t('actions.bring_me_there')))])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }